<template>
  <div>
    <EditorSimple
      :content.sync="elementData.text"
    />
    <div v-if="!isUpdatedContent(elementData.id)">
      <translations-bar
        v-show="!isUpdatedContent(elementData.id)"
        :id="elementData.id"
        :translations="translations(elementData.id)"
        :model="$constants.TRANSLATION_MODELS.MICROSITE_CONTENT"
      >
      </translations-bar>
    </div>
    <div v-else class="text__warning">
      You must update the translation after saving any changes in the field.
      Otherwise, the data can't be pulled to the client part of the app.
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EditorSimple from '../EditorSimple.vue';
import TranslationsBar from '../Translations/TranslationsBar.vue';

export default {
  name: 'RowElementText',
  components: {
    TranslationsBar,
    EditorSimple,
  },

  props: {
    elementData: {
      type: Object,
    },

    elementIndex: {
      type: Number,
    },

    rowIndex: {
      type: Number,
    },
  },

  data: () => ({
  }),

  methods: {
    ...mapActions({
      updateElement: 'microsite/updateElement',
    }),

    updateText() {
      const element = JSON.parse(
        JSON.stringify(this.elementData),
      );

      this.updateElement({
        rowIndex: this.rowIndex,
        elementIndex: this.elementIndex,
        newElementData: element,
      });
    },
  },

  computed: {
    ...mapGetters({
      translations: 'microsite/translations',
      isUpdatedContent: 'microsite/isUpdatedContent',
    }),

    text() {
      return this.elementData.text;
    },
  },

  watch: {
    text(value, old) {
      if (value !== old) {
        this.updateText();
      }
    },
  },
};
</script>

<style scoped>
.text__warning {
  color: #f44336;
}
</style>
